const LK_Export =({color,width,height})=>{
    return(
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" fill={color}  width={width} height={height} viewBox="0 0 116.99 116.99">
            {/* <defs>
                <style>
                .cls-1 {
                    fill: #005c8e;
                    stroke-width: 0px;
                }
                </style>
            </defs> */}
            <path class="cls-1" d="M79.29,56.33h-38.14v-21.34L.45,58.49l40.71,23.5v-21.34h38.14v-4.33ZM9.11,58.49l27.71-16v32s-27.71-16-27.71-16Z"/>
            <path class="cls-1" d="M111.53,30.45l-25.45-25.45L81.08,0H25.55v34.99h5V5h46.99v19.55c0,7.98,6.47,14.44,14.44,14.44h19.55v72.99H30.55v-29.99h-5v34.99h90.99V35.46l-5-5ZM91.99,33.99c-5.2,0-9.44-4.23-9.44-9.44V8.54l25.45,25.45h-16.01Z"/>
      </svg>
    );
};

export default LK_Export;
